export default "https://d1e6s5z4lzmgxx.cloudfront.net/1e48d3d4-9cd4-48c4-b169-1af184d58c4c/images/logo.svg?dfa25b22cdb9dbcf50ce8101e13fb686";